module.exports = __webpack_public_path__ + "img/trailer.d9d4abd6.svg";